<template>
    <v-layout align-center>
    <v-item-group
      v-model="window"
      class="shrink mr-4"
      mandatory
      tag="v-flex"
    >
      <v-item v-if="!hideMetrics"
      >
        <div slot-scope="{ active, toggle }">
          <v-btn text
            :input-value="active"
            @click="toggle"
          >
           <h6> Metrics </h6>
          </v-btn>
        </div>
      </v-item>
      <v-item v-if="!hideCollectorLogs"
      >
        <div slot-scope="{ active, toggle }">
          <v-btn text
            :input-value="active"
            @click="toggle"
          >
           <h6> Logs from collector box </h6>
          </v-btn>
        </div>
      </v-item>
      <v-item
      >
        <div slot-scope="{ active, toggle }">
          <v-btn text
            :input-value="active"
            @click="toggle"
          >
           <h6> Server Logs (Elk) </h6>
          </v-btn>
        </div>
      </v-item>
      <!-- <v-item
      >
        <div slot-scope="{ active, toggle }">
          <v-btn text
            :input-value="active"
            @click="toggle"
          >
           <h6> Server Logs (Elk/G1) </h6>
          </v-btn>
        </div>
      </v-item>       -->
      <v-item
      >
        <div slot-scope="{ active, toggle }">
          <v-btn text
            :input-value="active"
            @click="toggle"
          >
           <h6> Realtime Data Feed </h6>
          </v-btn>
        </div>
      </v-item>
    </v-item-group>

    <v-flex>
      <v-window
        v-model="window"
        class="elevation-1"
        vertical
      >
        <v-window-item v-if="!hideMetrics">
          <collector-metrics :keylike="metricsKeyLike" :srcIdFilter="metricsSrcIdFilter"></collector-metrics>
        </v-window-item>
        <v-window-item v-if="!hideCollectorLogs">
          <collector-logs :filter="logFilter" :numRowsPerPage=[5] :rowsPerPage=5></collector-logs>
        </v-window-item>
        <v-window-item>
          <elk-logs :srcIdFilter="logSrcIdFilter" :numRowsPerPage=[5] :rowsPerPage=5></elk-logs>
        </v-window-item>
        <!-- <v-window-item>
          <legacy-elk-logs :srcIdFilter="logSrcIdFilter" :numRowsPerPage=[5] :rowsPerPage=5></legacy-elk-logs>
        </v-window-item> -->
        <v-window-item>
          <system-rt-logs :srcIdFilter="logSrcIdFilter" :rowsPerPage=5></system-rt-logs>
        </v-window-item>
      </v-window>
    </v-flex>
  </v-layout>
</template>
<script>
  import CollectorMetrics from './CollectorMetrics.vue'
  import CollectorLogs from './CollectorLogsSubPanel.vue'
  import ElkLogsSubPanel from './ElkLogsSubPanel.vue'
  // import LegacyElkLogsSubPanel from './LegacyElkLogsSubPanel.vue'
  import SystemRTLogsSubPanel from './SystemRTLogsSubPanel.vue'
  export default {
    props: {
      metricsKeyLike: [Number, String],
      metricsSrcIdFilter: [Number, String],
      logSrcIdFilter: [Number, String],
      logFilter: String,
      hideMetrics: Boolean,
      hideCollectorLogs: Boolean
    },
    components: {
      'collector-metrics': CollectorMetrics,
      'collector-logs': CollectorLogs,
      'elk-logs': ElkLogsSubPanel,
      // 'legacy-elk-logs': LegacyElkLogsSubPanel,
      'system-rt-logs': SystemRTLogsSubPanel
    },
    data: () => ({
      length: 2,
      window: 0
    })
  }
</script>
